import { ROLE_ADMINS_EDIT, ROLE_READ } from '~/components/routes/administration/roles/permissions'
import type { PermissionTuple } from '~/utils/ability'
import type { PermissionRequirement } from '~/utils/rbac'

/**
 * Source unique des droits de l'écran « Utilisateurs & accès » — `/administration/access` (spec §9).
 *
 * Même règle que le module 25 : un seul endroit à mettre à jour, aucune dérive possible entre un
 * bouton et la page qu'il ouvre. **Aucune permission nouvelle** n'est nécessaire — les onze couples
 * de `users.bo-users.*` et `roles-admin.roles.*` couvrent tout l'écran, y compris les quatre
 * actions spéciales ouvertes par l'audit du 19/09.
 */

export const ACCESS_ADMIN_READ: PermissionTuple = ['read', 'users.bo-users.user']
export const ACCESS_ADMIN_ADD: PermissionTuple = ['add', 'users.bo-users.user']
export const ACCESS_ADMIN_EDIT: PermissionTuple = ['edit', 'users.bo-users.user']
export const ACCESS_ADMIN_DELETE: PermissionTuple = ['delete', 'users.bo-users.user']
export const ACCESS_ASSIGN_ROLE: PermissionTuple = ['assign-bo-role', 'users.bo-users.user']
export const ACCESS_RESET_PASSWORD: PermissionTuple = ['reset-password', 'users.bo-users.user']
export const ACCESS_API_KEY_READ: PermissionTuple = ['read', 'users.bo-users.api-key']

/** Lecture des rôles : matrice fusionnée, usage, axe « Par rôle ». */
export const ACCESS_ROLE_READ: PermissionTuple = ROLE_READ

/**
 * Ouverture de l'écran : dès que **l'un** des deux axes est accessible. Un Pôle IT sans lecture
 * des rôles doit pouvoir gérer des comptes ; un gestionnaire d'affectations sans lecture des
 * comptes doit pouvoir ouvrir l'axe « Par rôle ». L'axe interdit est alors désactivé avec le
 * tooltip des droits manquants, jamais masqué (§1.2).
 */
export const ACCESS_TAB_VIEW: PermissionRequirement = {
  any: [ACCESS_ADMIN_READ, ROLE_READ, ROLE_ADMINS_EDIT],
}
